import { HelmetDexteel } from "@dexteel/mesf-core";
import { Stack, Typography } from "@mui/material";

import { TestsBySectionTable } from "@/pages/configuration/pages/tests-by-section/components/TestsBySectionTable";
import { pageBgColor } from "@/utils/theme";

export const TestsBySectionSpecPage = () => (
	<>
		<HelmetDexteel title="Tests by Section" />
		<Stack
			spacing={1}
			sx={{ backgroundColor: pageBgColor, px: 2, pt: 2, pb: 1 }}
		>
			<Stack direction="row" spacing={1} alignItems="baseline">
				<Typography variant="h5" fontWeight={600}>
					Tests by Section
				</Typography>
				<Typography variant="body2" color="text.secondary">
					Read only — edited in Configuration
				</Typography>
			</Stack>

			<TestsBySectionTable readOnly />
		</Stack>
	</>
);
